import { message } from 'antd';

message.config({
  top: 15,
  duration: 3,
  maxCount: 1,
});

export { message as showMessage };
